<template>
  <base-container
    title="My Interests"
    view-link="/interestgroups"
    view-text="Manage Interests"
    header-central
    no-padding
  >
    <base-scroll-list header-central>
      <ol v-if="userFeed.length > 0" role="list">
        <li v-for="(item, index) in userFeed" :key="index" role="listitem">
          <card-list
            v-bind="item"
            @click="handleInterestClick(item)"
            :show-favourite="isEvent(item)"
          ></card-list>
        </li>
      </ol>
      <p v-else role="article">There is currently nothing to show.</p>
    </base-scroll-list>
  </base-container>
</template>

<script>
import {
  BaseContainer,
  BaseScrollableList as BaseScrollList,
} from "@/components/Containers";

const CardList = () => import("@/components/Containers/BaseCardList");
export default {
  name: "InterestsWidget",

  components: {
    BaseContainer,
    BaseScrollList,
    CardList,
  },

  data() {
    return {
      postLimit: 1,
      postFilter: [],
      userFeed: [],
    };
  },

  props: {
    limit: {
      type: [Number, String],
      default: 10,
    },
    contentTypes: {
      type: Array,
      default: () => ["news", "events", "content"],
    },
  },

  computed: {
    newsItems() {
      // return this.$store.state.widgets.news.articles;
    },
    storeItems() {
      return this.$store.state.widgets.interests.feed;
    },
  },

  methods: {
    isEvent(elem) {
      return elem.self.includes("event/")
    },
    handleInterestClick(elem) {
      const linkBits = elem.self.split("/");
      if (linkBits.includes("news")) {
        this.$router.push({
          name: "NewsRead",
          params: { id: elem.id },
        });
      }

      if (linkBits.includes("event")) {
        this.$router.push({
          name: "EventsSinglePage",
          params: { id: elem.id },
        });
      }
      if (linkBits.includes("content")) {
        this.$router.push({
          path: `/content/${elem.page_url}`,
        });
      }
    },
  },

  async mounted() {
    // need to get user interest groups
    await this.$store.dispatch('InterestGroups/getUserInterestGroups');
    await this.$store.dispatch("widgets/interests/setLimit", this.postLimit);
    await this.$store.dispatch("widgets/interests/setFilter", this.postFilter);
    await this.$store.dispatch("widgets/interests/getLargestLimit");
    this.$store
      .dispatch("widgets/interests/getFeed", {
        size: this.limit,
        contentTypes: this.contentTypes,
      })
      .then((resp) => {
        let returnFeed = resp
          .filter((item) => {
            return this.contentTypes.some((type) => {
              return item.self.includes(type);
            });
          })
          .slice(0, this.limit);
        this.userFeed = returnFeed;
      });
  },

  watch: {
    storeItems: {
      immediate: true,
      deep: true,
      handler(newVal) {
        let returnFeed = newVal
          .filter((item) => {
            return this.contentTypes.some((type) => {
              return item.self.includes(type);
            });
          })
          .slice(0, this.limit);
        this.userFeed = returnFeed;
      },
    },
    limit: {
      immediate: false,
      deep: false,
      handler(newValue, oldValue) {
        this.postLimit = newValue;
        this.$store
          .dispatch("widgets/interests/setLimit", this.postLimit)
          .then(() => {
            this.$store.dispatch("widgets/interests/clearCache").then(() => {
              this.$store
                .dispatch("widgets/interests/getFeed", {
                  size: this.limit,
                  contentTypes: this.contentTypes,
                })
                .then((resp) => {
                  let returnFeed = resp
                    .filter((item) => {
                      return this.contentTypes.some((type) => {
                        return item.self.includes(type);
                      });
                    })
                    .slice(0, this.limit);
                  this.userFeed = returnFeed;
                });
            });
          });
      },
    },
    contentTypes: {
      immediate: false,
      deep: false,
      handler(newValue, oldValue) {
        this.postFilter = newValue;
        this.$store
          .dispatch("widgets/interests/setFilter", this.postFilter)
          .then(() => {
            this.$store.dispatch("widgets/interests/clearCache").then(() => {
              this.$store
                .dispatch("widgets/interests/getFeed", {
                  size: this.limit,
                  contentTypes: this.contentTypes,
                })
                .then((resp) => {
                  let returnFeed = this.userFeed
                    .filter((item) => {
                      return newVal.some((type) => {
                        return item.self.includes(type);
                      });
                    })
                    .slice(0, this.limit);
                  this.userFeed = returnFeed;
                });
            });
          });
      },
    },
  },
};
</script>

<style lang="scss" scoped></style>
